import { Button } from '@components/button';
import { createForm } from '@components/form';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { disabledSectionStyle } from '@styles/theme';

import { ModalProps } from 'features/modals';
import { useStore } from 'models/Provider';

import { Cosigner, useEditDokobitCosigner } from './api';

const Form = createForm<Cosigner>();

export const DokobitEditCosignerModal = ({
  closeModal,
  cosigner,
}: ModalProps<{ cosigner: Cosigner }>) => {
  const { t } = useStore();
  const submit = useEditDokobitCosigner(cosigner.id, { onSuccess: closeModal });

  return (
    <div style={submit.isLoading ? disabledSectionStyle : {}}>
      <Stack space={4}>
        <Text
          font="heading2"
          text={t('integrations.dokobit.settings.cosigners.modal.edit.header')}
        />
        <Form onSubmit={(values) => submit.mutateAsync(values)}>
          <Form.TextField
            label={t('integrations.dokobit.settings.cosigners.modal.name.label')}
            id="name"
            validators={['required']}
            defaultValue={cosigner.name}
          />
          <Form.TextField
            label={t('integrations.dokobit.settings.cosigners.modal.email.label')}
            id="email"
            validators={['required', 'email']}
            defaultValue={cosigner.email}
          />
          <Form.TextField
            label={t('integrations.dokobit.settings.cosigners.modal.ssn.label')}
            id="ssn"
            validators={['ssn']}
            defaultValue={cosigner.ssn}
          />
          <Form.TextField
            label={t('integrations.dokobit.settings.cosigners.modal.phone.label')}
            id="phone"
            validators={['phoneNumber']}
            defaultValue={cosigner.phone}
          />
          <Form.Actions>
            <Button
              variant="secondary"
              text={t('integrations.dokobit.settings.cosigners.modal.cancel')}
              onClick={closeModal}
            />
            <Form.Submit text={t('integrations.dokobit.settings.cosigners.modal.save')} />
          </Form.Actions>
        </Form>
      </Stack>
    </div>
  );
};
